module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-arrow-down-a62d2914.svg";